import { createContext, useContext } from 'react';
export const AuthContext = createContext({
    user: null,
    organisation: null,
    needsAccess: false,
    diagnosticLead: null,
    loading: true,
});
export function useAuth() {
    return useContext(AuthContext);
}
